import { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Link } from 'react-router-dom';
import { signUp, closeErrorMsg, setInnSelected, changeLegalType } from "../../redux/modules/auth";
import InputField from "../common/input-field"
import { useForm } from "../../hooks/use-form";
import CheckboxField from "../common/checkbox-field"
import PopupMsg from "../common/popup-msg"

const Regist = () => {
  const dispatch = useDispatch();
  const auth = useSelector(state => state.auth);
  const mobile = useSelector(state => state.mobile);
  
  const [fields, setValue, setFieldValid, formIsValid, trigger, setTrigger, setValidate, setCheckValue, setAddress, setInn, setValueSelect, clearForm] = useForm({
    city: {
      value: '',
      name: 'city',
      type: 'text',
      placeholder: 'Город ведения деятельности *',
      validate: 'address',
      valid: false,
      valid_reg: false
    },
    legalType: {
      value: 'ООО',
      name: 'legalType',
      valid: true
    },
    inn: {
      value: '',
      name: 'inn',
      type: 'text',
      placeholder: 'ИНН *',
      validate: 'inn_ur',
      valid_reg: false,
      valid: false,
    },
    legalName: {
      value: '',
      name: 'legalName',
      type: 'text',
      placeholder: 'Юридическое название *',
      validate: 'text',
      valid: false,
      valid_reg: false,
      example: 'пример: Новостройки города'
    },
    brandName: {
      value: '',
      name: 'brandName',
      type: 'text',
      placeholder: 'Брендовое название *',
      validate: 'text',
      valid: false,
      valid_reg: false,
      example: 'пример: Новострой'
    },
    fio: {
      value: '',
      name: 'fio',
      type: 'text',
      placeholder: 'ФИО *',
      validate: 'text',
      valid: false,
      valid_reg: false
    },
    position: {
      value: '',
      name: 'position',
      type: 'text',
      placeholder: 'Должность *',
      validate: 'text',
      valid: false,
      valid_reg: false
    },
    phone: {
      value: '',
      name: 'phone',
      type: 'tel',
      placeholder: 'Телефон *',
      validate: 'phone',
      valid: false,
      valid_reg: false,
      example: !mobile ? 'На указанный номер будет отправлен код' : 'На этот номер будет отправлен код'
    },
    email: {
      value: '',
      name: 'email',
      type: 'text',
      placeholder: 'Электронная почта *',
      validate: 'email',
      valid: false,
      valid_reg: false
    },
    check1: {
      value: false,
      name: 'check1',
      validate: 'check',
      valid: false,
      valid_reg: false,
    },
    check2: {
      value: false,
      name: 'check2',
      validate: 'check',
      valid: false,
      valid_reg: false,
    }
  }, []);

  useEffect(() => {    
    document.title = 'Регистрация | Личный кабинет Брокера THE FIVE';
    window.addEventListener('scroll', scrolled);
    return () => {
        window.removeEventListener('scroll', scrolled);
    };
  });

  const scrolled = (e) => {
    const header = document.querySelector('.page-regist__header');
    const scrollTop = window.scrollY;
    scrollTop >= 30 ? header.classList.add('scroll') : header.classList.remove('scroll');
  };

  const handleSubmit = (e) => {
    e.preventDefault();    

    if (formIsValid()) {
     dispatch(
      signUp(
        {
          cmd: 'agents-add',
          legalType: fields.legalType.value,
          inn: fields.inn.value,
          legalName: fields.legalName.value,
          brandName: fields.brandName.value,
          city: fields.city.value,
          fio: fields.fio.value,
          position: fields.position.value,
          phone: fields.phone.value.replace(/[^0-9]/g, ''),
          email: fields.email.value,
          //ReturnDebugData: true
        }
      ))
    } 
  }

  const handleChangeLegalType = (value) => {
    dispatch(setInnSelected(false));
    setCheckValue('legalType', value);
    dispatch(changeLegalType(value))
  }
  
  if(auth.is_veryfied && auth.is_loggined) {
    return <Navigate to='/' replace />
  }

  return (
    <div className="page page-regist">
      <div className="page-regist__header">
        <div className="logo"></div>
        {mobile && <div className="page-regist__title">Регистрация</div>}
      </div>
      
      <form className="form fadeIn" onSubmit={handleSubmit}>
        <div className="form__title">Регистрация</div>        
        <div className="form__radios">
          <div className="legal-form-label">Организационно-правовая форма</div>
          <div className="legal-form">
            <div 
              className={fields.legalType.value === 'ООО' ? "legal-form__item legal-form__item_active" : "legal-form__item"} 
              onClick={() => handleChangeLegalType('ООО')}
              valid={fields.legalType.value  ? 'true' : 'false'}
              error={!fields.legalType.value  && trigger ? 'true' : 'false'}
            >
              <div>ООО</div>
              {!mobile && <span dangerouslySetInnerHTML={{ __html: 'Общество с ограниченной ответственностью'}} />}
            </div>
            <div 
              className={fields.legalType.value  === 'ИП' ? "legal-form__item legal-form__item_active" : "legal-form__item"} 
              onClick={() => handleChangeLegalType('ИП')}
              valid={fields.legalType.value  ? 'true' : 'false'}
              error={!fields.legalType.value  && trigger ? 'true' : 'false'}
            >
              <div>ИП</div>
              {!mobile && <span dangerouslySetInnerHTML={{ __html: 'Индивидуальный <br/>предприниматель'}} />} 
            </div>
            <div 
              className={fields.legalType.value  === 'Самозанятый' ? "legal-form__item legal-form__item_active" : "legal-form__item"} 
              onClick={() => handleChangeLegalType('Самозанятый')}
              valid={fields.legalType.value  ? 'true' : 'false'}
              error={!fields.legalType.value  && trigger ? 'true' : 'false'}
            >
              <div>Самозанятый</div>
            </div>
          </div>
        </div>
        {fields.legalType.value !== 'Самозанятый' && (<>
          <div className="form__columns">
            <div className="form__column">
              <InputField
                trigger={trigger}
                setFieldValid={setFieldValid}
                setValue={setValue}
                setInn={setInn}
                setValueSelect={setValueSelect}
                {...fields.inn}
              />
              <InputField
                trigger={trigger}
                setFieldValid={setFieldValid}
                setValue={setValue}
                {...fields.legalName}
              />
              <InputField
                trigger={trigger}
                setFieldValid={setFieldValid}
                setValue={setValue}
                {...fields.brandName}
              />
              <InputField
                trigger={trigger}
                setFieldValid={setFieldValid}
                setAddress={setAddress}
                setValue={setValue}
                {...fields.city}
              />
            </div>
            <div className="form__column">
              <InputField
                trigger={trigger}
                setFieldValid={setFieldValid}
                setValue={setValue}
                {...fields.fio}
              />
              <InputField
                trigger={trigger}
                setFieldValid={setFieldValid}
                setValue={setValue}
                {...fields.position}
              />
              <InputField
                trigger={trigger}
                setFieldValid={setFieldValid}
                setValue={setValue}
                {...fields.phone}
              />
              <InputField
                trigger={trigger}
                setFieldValid={setFieldValid}
                setValue={setValue}
                {...fields.email}
              />
            </div>
          </div>
          <div className="form__comment">* Обязательные поля</div>
          <div className="form__bottom">
            <div className="form__checkboxes">
              <CheckboxField
                trigger={trigger}
                setFieldValid={setFieldValid}
                setCheckValue={setCheckValue}
                text={'Нажимая кнопку «Зарегистрироваться», Вы даете <a href="/upload/files/consent_personal_data.pdf" target="_blank">согласие на обработку персональных данных</a> и соглашаетесь с <a href="/upload/files/personal_data_policy.pdf" target="_blank">Политикой в отношении обработки персональных данных</a>.'}
                {...fields.check1}
              />
              <CheckboxField
                trigger={trigger}
                setFieldValid={setFieldValid}
                setCheckValue={setCheckValue}
                text={'Нажимая кнопку «Зарегистрироваться», Вы принимаете условия <a href="/upload/files/terms_of_service.pdf" target="_blank">Пользовательского соглашения</a>.'}
                {...fields.check2}
              />
            </div>
            <div className="form__buttons">
              <button type={'submit'} className={formIsValid() ? "btn" : "btn btn_disable"}>Зарегистрироваться</button>
              <Link to="/login" className={mobile ? "btn btn_empty" : "btn"}>&nbsp;&nbsp;У меня есть аккаунт. Войти&nbsp;&nbsp;</Link>
            </div>
          </div>
        </>)}
        {fields.legalType.value == 'Самозанятый' && (<div className="partners">
          <div className="partners__title">Уважаемый партнер! Мы работаем с Самозанятыми через площадки-агрегаторы</div>
          <div className="partners-list">
            <a href="https://msk.nmarket.pro/" target="_blank" className="partners-list__item">
              <div className="partners-list__img"><img src="/img/partner1.svg" alt="" /></div>
            </a>
            <a href="https://trendagent.ru/agency/" target="_blank" className="partners-list__item">
              <div className="partners-list__img"><img src="/img/partner2.svg" alt="" /></div>
            </a>
            <a href="https://dombook.plus/" target="_blank" className="partners-list__item">
              <div className="partners-list__img"><img src="/img/partner3.svg" alt="" /></div>
            </a>
            <a href="https://redcat.ai/ru" target="_blank" className="partners-list__item">
              <div className="partners-list__img"><img src="/img/partner4.svg" alt="" /></div>
            </a>
            <a href="https://alfa.tymy.io/" target="_blank" className="partners-list__item">
              <div className="partners-list__img"><img src="/img/partner5.svg" alt="" /></div>
            </a>
          </div>
        </div>)}
      </form>
      {auth.error && <PopupMsg message={auth.error} close={closeErrorMsg()} />}
    </div>
  )
}

export default Regist